import React from "react";
import {
  FiBell,
  FiChevronRight,
  FiGlobe,
  FiLock,
  FiLogOut,
  FiUser,
} from "react-icons/fi";
import SettingsHeader from "./SettingsHeader";

const UserIcon = FiUser;
const BellIcon = FiBell;
const GlobeIcon = FiGlobe;
const LockIcon = FiLock;
const LogoutIcon = FiLogOut;
const ChevronIcon = FiChevronRight;

const SettingsRow = ({ icon: Icon, title, subtitle, danger = false, onClick }) => (
  <button
    type="button"
    className={`pp-settings-row pp-settings-menu-row ${danger ? "is-danger" : ""}`}
    onClick={onClick}
  >
    <span className="pp-settings-row-icon pp-settings-menu-icon" aria-hidden="true">
      <Icon />
    </span>
    <span className="pp-settings-row-copy pp-settings-menu-copy">
      <span className="pp-settings-row-title pp-settings-menu-title">{title}</span>
      {subtitle && <span className="pp-settings-row-subtitle pp-settings-menu-subtitle">{subtitle}</span>}
    </span>
    <ChevronIcon className="pp-settings-row-chevron pp-settings-menu-chevron" aria-hidden="true" />
  </button>
);

export default function SettingsOverview({ t, onBack, onNavigate, onLogout }) {
  return (
    <div className="pp-settings-screen pp-settings-overview-screen">
      <SettingsHeader
        t={t}
        title={t("parentPortal.settings.title", { defaultValue: "Settings" })}
        subtitle={t("parentPortal.settings.subtitle", { defaultValue: "Manage your account and preferences" })}
        onBack={onBack}
      />

      <section className="pp-settings-list pp-settings-menu-card" aria-label={t("parentPortal.settings.title", { defaultValue: "Settings" })}>
        <SettingsRow
          icon={UserIcon}
          title={t("parentPortal.settings.profile", { defaultValue: "Profile" })}
          subtitle={t("parentPortal.settings.profile_subtitle", { defaultValue: "Manage your account details" })}
          onClick={() => onNavigate("profile")}
        />
        <SettingsRow
          icon={BellIcon}
          title={t("parentPortal.settings.notifications", { defaultValue: "Notifications" })}
          subtitle={t("parentPortal.settings.notifications_subtitle", { defaultValue: "Choose what you want to receive" })}
          onClick={() => onNavigate("notifications")}
        />
        <SettingsRow
          icon={GlobeIcon}
          title={t("parentPortal.settings.language", { defaultValue: "Language" })}
          subtitle={t("parentPortal.settings.language_subtitle", { defaultValue: "Set your preferred language" })}
          onClick={() => onNavigate("language")}
        />
        <SettingsRow
          icon={LockIcon}
          title={t("parentPortal.settings.security", { defaultValue: "Security" })}
          subtitle={t("parentPortal.settings.security_subtitle", { defaultValue: "Password and security" })}
          onClick={() => onNavigate("security")}
        />
        <SettingsRow
          icon={LogoutIcon}
          title={t("parentPortal.settings.logout", { defaultValue: "Log out" })}
          subtitle={t("parentPortal.settings.logout_subtitle", { defaultValue: "Safely log out of your account" })}
          danger
          onClick={onLogout}
        />
      </section>
    </div>
  );
}
